import React from 'react';
import { ListWrapper } from './CouponsList.styles';
import { CouponListItem } from './components';

type Props = {
  coupons: {
    code: string;
    value: string;
    description: string;
  }[];
};
export const CouponsList = ({ coupons }: Props) => {
  return (
    <ListWrapper>
      {coupons?.map(({ code, value, description }) => (
        <CouponListItem
          key={code}
          code={code}
          value={value}
          description={description}
        />
      ))}
    </ListWrapper>
  );
};
